module.exports = __webpack_public_path__ + "img/cases-part1-7.c4f23288.png";